<div class="detail-section">
    <div class="upload_pricing">
     <img src="../../../../assets/images/NotFound.svg">
     <div class="pricing_label">
       <label>No Results Found</label>
     </div>
    </div>
   </div>
